import json from "./json.js";
import jsarray from "./jsarray.js";
import xml from "./xml.js";
import csv from "./csv.js";
import html from "./html.js";
import htmltable from "./htmltable";
import excel from "./excel";

const DataDriver={ json, jsarray, xml, csv, html, htmltable, excel };

export default DataDriver;